import { useEffect, useState } from "react";
import WitnessInfo from "../components/WitnessInfo";
import PageWrapper from "../../shared/wizard/PageWrapper";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Styles from "../AnonForms.module.css";
import { textToBoolean } from "../../../utilities/dataUtilities";
import inputUtilities from "../../../utilities/forms/formInputUtilities";
import { yesNoUnsure } from "../../../constants/options";
import { useSelector } from "react-redux";

function Witnesses({
  fields,
  utilities,
  witnesses,
  setWitnesses,
}) {
  let witnessObj = useSelector((state) => state.anonAutoForm.witnessObj);
  const [showButton, setShowButton] = useState(witnesses?.length < 4);
  const { createToggleInput } = utilities;

  const addWitness = () => {
    const newWitnesses = [...witnesses];
    const newWitness = { ...witnessObj };
    for (let fieldName in newWitness) {
      newWitness[fieldName] = {
        ...newWitness[fieldName],
        fieldName: `${newWitness[fieldName].fieldName}${witnesses.length}`,
      };
    } //destructuring inner objects so it shouldn't point to witnessObj fields and changing fieldNames so should be unique
    newWitnesses.push(newWitness);
    setWitnesses(newWitnesses);
  };

  const createWitness = (witness, index) => {
    const setWitness = (wit) => {
      const oldWitnessInfo = [...witnesses];
      oldWitnessInfo[index] = wit;
      setWitnesses(oldWitnessInfo);
    };
    const createWitInput = inputUtilities(
      witness,
      setWitness,
      Styles
    ).createNoLabelInput;
    return (
      <li key={index} className={`${Styles.witnessContainer} ${Styles.inputContainer}`}>
            <WitnessInfo
                  key={index}
                  witness={witness}
                  createInput={createWitInput}
                />
          <i className={`fa fa-trash ${Styles.trash}`}>
                  <FontAwesomeIcon
                    icon={faTrashAlt}
                    onClick={() => {
                      const info = [...witnesses];
                      info.splice(index, 1);
                      setWitnesses(info);
                    }}
                  />
                </i>
      </li>
    );
  }; //displays fields for a single witness

  useEffect(() => {
    if (textToBoolean(fields.witnessesPresent.value)) {
      if (witnesses?.length < 1) {
        addWitness();
      }
    } else {
      setWitnesses([]);
    }
  }, [fields.witnessesPresent.value])

  useEffect(() => {
    if (witnesses?.length < 4) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  }, [witnesses?.length])

  return (
    <PageWrapper legendInfo="Witness Information (if any):">
      {createToggleInput(fields.witnessesPresent, "100%", yesNoUnsure, true)}
      
      {textToBoolean(fields.witnessesPresent.value) && (
        <div className={Styles.fadeIn}>
          {witnesses.map((wit, i) => createWitness(wit, i))}
          <div className={Styles.addButtonDiv}>
            {showButton && (
              <button
                onClick={addWitness}
                type="button"
                className={Styles.addButton}
              >
                Add Another
              </button>
            )}
          </div>
        </div>
      )}
    </PageWrapper>
  );
}

export default Witnesses;
